import { render } from "./Step3.vue?vue&type=template&id=20507dfa&ts=true"
import script from "./Step3.vue?vue&type=script&lang=ts"
export * from "./Step3.vue?vue&type=script&lang=ts"

import exportComponent from "/home/meiyeer/irb-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__